import { useState } from 'react'

import { isPageUnloading } from '@/utils'

export const useAsyncError = () => {
  const [, setError] = useState()

  return (error: unknown) => {
    if (isPageUnloading()) return

    setError(() => {
      throw error
    })
  }
}
